/**
 * User: n.gorte
 * Date: 20.10.2020
 * Time: 16:13
 */
import L from 'external/leaflet';

export const ColorSelectControl = L.Control.extend({
    options: {
        position: 'bottomleft'
    },

    initialize(options){
        L.Util.setOptions(this, options);
        this._onClick = this._onClick.bind(this);
    },

    onAdd(map){
        let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
        container.style.backgroundColor = this.options.color;
        container.style.cursor = 'pointer';
        container.style.height = '26px';
        container.style.width = '26px';
        container.title = 'Farb-Auswahl';
        container.onclick = this._onClick;
        return container;
    },

    onRemove(map) {
        this._container.onclick = null;
        this._container = null;
    },

    enable(){
        this._active = true;
    },

    disable(){
        this._active = false;
    },

    isActive(){
        return this._active;
    },

    setColor(color) {
        this._container.style.backgroundColor = color;
    },

    _onClick(e){
        if (e) {
            L.DomEvent.stop(e);
        }
        this._active = !this._active;
        if (this._active) {
            this.enable();
        } else {
            this.disable();
        }
        this.options.onClick && this.options.onClick(this._active);
    }
});



// WEBPACK FOOTER //
// ./js/plugins/DrawerPlugin/ColorSelectControl.js